export const LOCATION_MAP = {
    "AF": ["AO", "BF", "BI", "BJ", "BW", "CD", "CF", "CG", "CI", "CM", "CV", "DJ", "DZ", "EG", "EH", "ER", "ET", "GA", "GH", "GM", "GN", "GQ", "GW", "KE", "KM", "LR", "LS", "LY", "MA", "MG", "ML", "MR", "MU", "MW", "MZ", "NA", "NE", "NG", "RE", "RW", "SC", "SD", "SH", "SL", "SN", "SO", "SS", "ST", "SZ", "TD", "TG", "TN", "TZ", "UG", "YT", "ZA", "ZM", "ZW"],
    "AN": ["AQ", "BV", "GS", "HM", "TF"],
    "AS": ["AE", "AF", "AM", "AZ", "BD", "BH", "BN", "BT", "CC", "CN", "CX", "CY", "GE", "HK", "ID", "IL", "IN", "IO", "IQ", "IR", "JO", "JP", "KG", "KH", "KP", "KR", "KW", "KZ", "LA", "LB", "LK", "MM", "MN", "MO", "MV", "MY", "NP", "OM", "PH", "PK", "PS", "QA", "SA", "SG", "SY", "TH", "TJ", "TL", "TM", "TW", "UZ", "VN", "YE"],
    "EU": ["AD", "AL", "AT", "AX", "BA", "BE", "BG", "BY", "CH", "CZ", "DE", "DK", "EE", "ES", "FI", "FO", "FR", "GB", "GG", "GI", "GR", "HR", "HU", "IE", "IM", "IS", "IT", "JE", "LI", "LT", "LU", "LV", "MC", "MD", "ME", "MK", "MT", "NL", "NO", "PL", "PT", "RO", "RS", "RU", "SE", "SI", "SJ", "SK", "SM", "TR", "UA", "VA"],
    "NA": ["AG", "AI", "AW", "BB", "BL", "BM", "BQ", "BS", "BZ", "CA", "CR", "CU", "CW", "DM", "DO", "GD", "GL", "GP", "GT", "HN", "HT", "JM", "KN", "KY", "LC", "MF", "MQ", "MS", "MX", "NI", "PA", "PM", "PR", "SV", "SX", "TC", "TT", "US", "VC", "VG", "VI"],
    "OC": ["AS", "AU", "CK", "FJ", "FM", "GU", "KI", "MH", "MP", "NC", "NF", "NR", "NU", "NZ", "PF", "PG", "PN", "PW", "SB", "TK", "TO", "TV", "UM", "VU", "WF", "WS"],
    "SA": ["AR", "BO", "BR", "CL", "CO", "EC", "FK", "GF", "GY", "PE", "PY", "SR", "UY", "VE"]
};

export const CURRENCIES = {
    USD: "$",
    EUR: "€"
};

export const PASSWORD_MIN_LENGTH = 6;
export const PASSWORD_MAX_LENGTH = 32;

export const EMPLOYEES_COUNT_VALUES = [
    {
        code: 'UNKNOWN',
        name: 'orgs.unknown_label'
    },
    {
        code: 'ONE_TO_TEN',
        name: '1-10'
    },
    {
        code: 'TEN_TO_FIFTY',
        name: '10-50'
    },
    {
        code: 'FIFTY_TO_TWO_HUNDRED',
        name: '50-200'
    },
    {
        code: 'TWO_HUNDRED_TO_FIVE_HUNDRED',
        name: '200-500'
    },
    {
        code: 'FIVE_HUNDRED_TO_ONE_THOUSAND',
        name: '500-1000'
    },
    {
        code: 'ONE_THOUSAND_TO_FIVE_THOUSAND',
        name: '1000-5000'
    },
    {
        code: 'FIVE_THOUSAND_TO_TEN_THOUSAND',
        name: '5000-10000'
    },
    {
        code: 'TEN_THOUSAND_PLUS',
        name: '10000+'
    }
];

export const ORGANIZATION_TYPES = [
    {
        code: 'EDU_ORG',
        name: 'shared.edu_org_label'
    },
    {
        code: 'COMPANY',
        name: 'shared.company_label'
    }
];

export const ORGANIZATION_AVAILABLE_FLAGS = ['hasIVs', 'providesMoocCertificates'];

export const FLAGS = {
    'hasIVs': 'orgs.has_accreditation_groups_label',
    'verifiesIdentities': 'orgs.verifies_identities_label',
    'providesMoocCertificates': 'orgs.provides_mooc_certificates_label',
};

export const AVAILABLE_CONSENT_PERIODS = {
    WEEK: 'week',
    MONTH: 'month',
    YEAR: 'year',
    FOREVER: 'forever'
};

export const AVAILABLE_CONSENT_PERIODS_TO_APPROVE_AFTER_REQUEST = {
    WEEK: 'week',
    MONTH: 'month'
};

export const REFUSE_REASONS = ["TIMING1", "TIMING2", "INTEREST", "MISMATCH", "ANOTHER"];

export const REQUEST_EMAIL_SOURCE_REQUESTER = 'REQUESTER';
export const REQUEST_EMAIL_SOURCE_DEPARTMENT = 'DEPARTMENT';
export const REQUEST_EMAIL_SOURCE_NONE = 'NONE';

export const AVAILABLE_PRIOR_CONSENT_TYPES = {
    PERSON: 'PERSON',
    ORGANIZATION: 'ORGANIZATION',
    ANYONE: 'ANYONE'
};

export const BOOK_DOMAINS = [
    "ADMINISTRATION_AND_MANAGEMENT",
    "COMMUNICATION",
    "CULTURE_AND_SPORTS_AND_ENTERTAINMENT",
    "GOV",
    "IT",
    "LAND_AND_SEA_AND_AIR",
    "LEGAL",
    "LIFE_AND_DEATH",
    "MANUFACTURING_AND_WORKING_WITH_MATERIALS",
    "SALES_AND_MARKETING",
    "SERVICES",
    "STEM",
    "OTHER"
];

export const OAUTH_ERRORS = {
    INVALID_REQUEST: "invalid_request",
    UNAUTHORIZED_CLIENT: "unauthorized_client",
    ACCESS_DENIED: "access_denied",
    UNSUPPORTED_RESPONSE_TYPE: "unsupported_response_type",
    INVALID_SCOPE: "invalid_scope",
    SERVER_ERROR: "server_error",
    TEMPORARILY_UNAVAILABLE: "temporarily_unavailable"
};

export const TITLES_LANGS = ["de", "es", "nl", "fr", "ja", "ru", "original", "en"];

export const NOTIFICATION_TYPES = {
    PENDING_ORGANIZATIONS: 'pending_organizations',
    REVIEW_FAILED_ACCREDITATIONS: 'review_failed_accreditations',
    VALIDATE_ACCREDITATIONS: 'validate_accreditations',
    PENDING_ACCREDITATIONS: 'pending_accreditations',
    PENDING_CONSENTS: 'pending_consents',
    PENDING_ACCREDITATION_REQUESTS: 'pending_accreditation_requests',
    UNREFERENCED_ACCREDITATION_REQUESTS_BY_AGS: 'unreferenced_accreditation_requests_by_ags',
    UNREFERENCED_ACCREDITATION_REQUESTS_BY_DOMAINS: 'unreferenced_accreditation_requests_by_domains',
    REJECTED_BY_APPLICANTS_ACCREDITATIONS: 'rejected_by_applicants_accreditations',
    REJECTED_BY_VALIDATORS_ACCREDITATIONS: 'rejected_by_validators_accreditations',
    ANCHOR_SECURITY_GOT_IT: 'anchor_security_got_it',
    INSERTER_SECURITY_NO_CERTIFICATE: "inserter_security_no_certificate",
    ADMIN_SECURITY_NOTIFICATIONS: "admin_security_notification"
};

export const ACCREDITATION_REQUEST_STATUSES = {
    REQUEST_IN_PROCESS: 'REQUEST_IN_PROCESS',
    REQUEST_SUBMITTED: 'REQUEST_SUBMITTED',
    REQUEST_REJECTED: 'REQUEST_REJECTED'
};

export const ASSISTANT_TYPES = {
    PROCESS_ASSISTANT: 'process_assistant',
    FINANCIAL_ASSISTANT: 'financial_assistant'
};

export const EXPOSE_NID_OPTIONS = {
    EXPOSE_FULL: 'EXPOSE_FULL',
    EXPOSE_SHORT: 'EXPOSE_SHORT',
    NOT_EXPOSE: 'NOT_EXPOSE'
};

export const TRANSACTION_TYPES = {
    PAYED_CONSENT_REQUEST_REMUNERATION: 'PAYED_CONSENT_REQUEST_REMUNERATION'
};


// WEBPACK FOOTER //
// ./src/constants/constants.js